/**
 * PostHog flag switching artifact frames from the presigned object-storage
 * `url` to the server's `html_url`, the render route that carries a view token
 * in its path and redirects to the artifact's own domain.
 *
 * Off (the default, and while flags are still loading) every frame keeps
 * loading `url` exactly as today. On, the chat canvas, the page panel and the
 * task thumbnail load `html_url` instead, so an image the agent embedded as a
 * relative `file/{id}` resolves under the token and renders.
 *
 * The flag exists for the rollout order, not as a product switch: the frames
 * switch first, and only once they have the agent starts writing `file/{id}`
 * references, which an `url`-served frame would show as a broken image.
 */
export const ARTIFACT_HTML_VIA_RENDER_FLAG = 'artifact_html_via_render';
